import { createContext } from "react";

const IsSsrMobileContext = createContext(false);

export { IsSsrMobileContext };
